import { render, staticRenderFns } from "./Registry.vue?vue&type=template&id=f8bf0d5c&scoped=true&"
import script from "./Registry.vue?vue&type=script&lang=ts&"
export * from "./Registry.vue?vue&type=script&lang=ts&"
import style0 from "./Registry.vue?vue&type=style&index=0&id=f8bf0d5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bf0d5c",
  null
  
)

export default component.exports